
import config from '@/config/config.js'

export default {
  /**
   * 来源说明（格式html）
   */
  sourceTooltipExplain(){
    let str =  "来源：企业制作:企业制作的学习资源;平台分配:平台分配的学习资源;"
    if (config.freeCourse) {
       str += "平台课程:从平台课程中加入的学习资源";
    } else {
      str += "平台商城：从商城加入学习资源,根据课程设置的价格进行收费";
    }
    return str;
  },
  /**
   * 翻译来源
   * @param  {String} url 目标文件地址
   * @return {cb}
   */
  translateSourceName(row) {
    if (row.isMallImport != 1 && row.sourceId) {
      return "平台分配";
    } else if (row.isMallImport!=1 && !row.sourceId) {
      return "企业制作";
    } else {
      if (config.freeCourse) {
        return "平台课程";
      } else {
        return "平台商城";
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/courseUtils.js